import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";
import "./static/styles.css"

const pages = [
  {
    path: "/",
    title: "Welcome",
    content: pageLoader(() => import("./welcome.md")),
  },
  {
    path: "/typography",
    title: "Typography",
    content: pageLoader(() => import("./typography.md")),
  },
  {
    path: "/colors",
    title: "Colors",
    content: pageLoader(() => import("./colors.md")),
  },
  {
    path: "/components",
    title: "Components",
    responsiveSizes: [
      { name: "watch", width: 272, height: 340 },
      { name: "tablet", width: 1024, height: 768 },
      { name: "desktop", width: 1920, height: 1080 },
    ],
    pages: [
      {
        path: "/components/header",
        title: "Header",
        content: pageLoader(() => import("./components/header.md")),
      },
      {
        path: "/components/header-homepage",
        title: "Header Homepage",
        content: pageLoader(() => import("./components/header-homepage.md")),
      },
      {
        path: "/components/front-page-panel",
        title: "Front Page Panel",
        content: pageLoader(() => import("./components/front-page-panel.md")),
      },
      {
        path: "/components/labels",
        title: "Labels",
        content: pageLoader(() => import("./components/labels.md")),
      },
      {
        path: "/components/notifications",
        title: "Notifications",
        content: pageLoader(() => import("./components/notifications.md")),
      },
      {
        path: "/components/tabs",
        title: "Tabs",
        content: pageLoader(() => import("./components/tabs.md")),
      },
      {
        path: "/components/tooltip",
        title: "Tooltip",
        content: pageLoader(() => import("./components/tooltip.md")),
      },
      {
        path: "/components/forms",
        title: "Forms",
        content: pageLoader(() => import("./components/forms.md")),
      },
      {
        path: "/components/buttons",
        title: "Buttons",
        content: pageLoader(() => import("./components/buttons.md")),
      },
      {
        path: "/components/footer",
        title: "Footer",
        content: pageLoader(() => import("./components/footer.md")),
      },
    ],
  },
  {
    path: "/style",
    title: "Style",
    // content: pageLoader(() => import("./colors.md")),
    pages: [
      {
        path: "/style/email",
        title: "Email",
        content: pageLoader(() => import("./styles/email.md")),
      },
      {
        path: "/style/punctuation",
        title: "Links and formatting",
        content: pageLoader(() => import("./styles/punctuation.md")),
      },
      {
        path: "/style/sms",
        title: "SMS",
        content: pageLoader(() => import("./styles/sms.md")),
      },
    ],
  },
];

ReactDOM.render(
  <Catalog 
    title="GloBird Energy" 
    logoSrc="GloBird_web_logo.svg"
    pages={pages}
    theme={
      {
        textColor: "#2E2E2D",
        linkColor: "#EC008C",
        pageHeadingBackground: "#EC008C",
        fontFamily: "'Arial', sans-serif",
        fontHeading: "'Rubik', sans-serif",
        brandColor: "#2E2E2D",
      }
    } 
    responsiveSizes={
      [
        {name: 'mobile', width: 375, height: 667},
        {name: 'tablet (Portrait)', width: 768, height: 1024},
        {name: 'tablet (Landscape)', width: 1024, height: 768},
        {name: 'laptop', width: 1280, height: 800},
        {name: 'desktop', width: 1536, height: 864},
        {name: 'xl desktop', width: 1920, height: 1080},
      ]    
    } 
      
  />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js